<script>
import _ from 'lodash'

export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [Array],
      default: () => [],
    },
    disabled: {
      type: Boolean,
    },
    editMode: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputContainerClass: {
      type: String,
      default: '',
    },
    isChanged: {
      type: Boolean,
    },
  },
  data() {
    return {
      modelValue: this.value,
      inputValue: '',
    }
  },
  watch: {
    value: {
      handler: function (newVal) {
        this.modelValue = newVal
      },
    },
  },
  methods: {
    addNewValue() {
      if (!this.inputValue) {
        return
      }
      this.modelValue = _.union(this.modelValue, [this.inputValue])
      this.inputValue = ''
      this.emitNewValue()
    },
    removeValue(value) {
      this.modelValue = _.without(this.modelValue, value)
      this.emitNewValue()
    },
    emitNewValue() {
      this.$emit('update:value', this.modelValue)
      this.$refs.provider.syncValue(this.modelValue)
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.labelContainer">
      <div>
        <p :class="$style.label" class="p1">{{ label }}:</p>
      </div>
    </div>
    <div v-if="!editMode && !modelValue.length" :class="$style.valueContainer">
      <h4 :class="$style.value">{{ 'N/A' }}</h4>
    </div>
    <div v-if="editMode" class="position-relative" :class="inputContainerClass">
      <BaseInputText
        v-model="inputValue"
        class="mb-3"
        :disabled="disabled"
        :name="name || label"
        :placeholder="placeholder"
        :changed="inputValue !== '' || isChanged"
        @keyup.enter="addNewValue" />
      <BaseIcon
        :class="[inputValue ? 'color-primary-blue-filter' : 'color-gray-filter', $style.addIcon]"
        name="plus"
        @click.native="addNewValue" />
    </div>
    <ValidationProvider ref="provider" :name="label">
      <input v-model="modelValue" type="text" hidden />
    </ValidationProvider>
    <div :class="$style.multipleItemsList">
      <div
        v-for="itemValue in modelValue"
        :key="itemValue"
        :class="$style.individualItem"
        :style="{ 'padding-right': editMode ? '26px' : '10px' }">
        <span>{{ itemValue }}</span>
        <i v-if="editMode" aria-hidden="true" tabindex="1" @click="removeValue(itemValue)"></i>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  overflow-y: initial;

  div[class*='errorContainer'] {
    position: relative;
  }
}

.valueContainer {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  word-break: break-all;

  h4 {
    margin: 0;
  }
}

.labelContainer {
  position: relative;
  display: flex;
  align-items: center;

  div[data-tooltip-icon] {
    position: initial;
    display: flex;
    align-items: center;
    margin-left: 8px;
  }
}

.label {
  margin-top: 10px;
  margin-bottom: 10px;
  color: $dark-gray;
}

.value {
  font-weight: 700;
  color: $primary-blue;
  overflow-wrap: break-word;
}

.addIcon {
  position: absolute;
  top: 50%;
  right: 18px;
  font-size: 18px;
  cursor: pointer;
  transform: translate(0, -50%);
}

.individualItem {
  position: relative;
  display: inline-block;
  max-width: 100%;
  padding: 6px 10px 8px 10px;
  margin-right: 10px;
  margin-bottom: 5px;
  overflow: hidden;
  line-height: 1;
  color: $white;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: $primary-blue;
  border-radius: 16px;

  span {
    font-size: 14px;
  }

  i {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 22px;
    margin-left: 7px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    border-radius: 5px;
    transition: all 0.2s ease;

    &::after {
      font-size: 14px;
      color: #fff;
      content: '\D7';
    }
  }
}

.multipleItemsList {
  display: flex;
  flex-wrap: wrap;
}
</style>
